export const USER_PERSONA_MODAL = 'user_persona_modal';
